import React from 'react'
import { Navigate } from 'react-router-dom'

import { FEATURES_TYPE } from '@constants'
import { MY_BUSINESS_ROUTES } from '@constants/routes'
import AppLayout from 'Layout'
import MyBusinessRevenuePage  from './Revenue/Page'
import MyBusinessFleetPage    from './Fleet/Page'
import MyBusinessForecastPage from './Forecast/Page'
import MyBusinessMarketPage   from './Market/Page'
import MyBusinessPerformancePage from './Performance/Page'
import MyBusinessAdminPage    from './Admin'

/**
 * My Business — Module A routes.
 *
 * Wraps a sub-tree under /my-business with the standard AppLayout.
 * Landing screen is "Revenue" (A1). Fleet (A3) is the second screen.
 *
 * Gated by two feature flags:
 *   - `my_business`        → dashboards (Revenue / Fleet / Forecast)
 *   - `my_business_admin`  → mapping admins (Channel, Office, Category,
 *                             Agency → Price Seeker bridge)
 *
 * Auto-granted to canarias.com (see session.py); editable via the user
 * admin's `extra_features` CSV for everyone else.
 */
export const MyBusinessRoutes = userData => {
	if (!userData?.featuresV2?.my_business) return []

	const dashboardRoutes = [
		{
			path: MY_BUSINESS_ROUTES.REVENUE_PATH,
			title: MY_BUSINESS_ROUTES.REVENUE_TITLE,
			element: <MyBusinessRevenuePage/>,
		},
		{
			path: MY_BUSINESS_ROUTES.FLEET_PATH,
			title: MY_BUSINESS_ROUTES.FLEET_TITLE,
			element: <MyBusinessFleetPage/>,
		},
		{
			path: MY_BUSINESS_ROUTES.FORECAST_PATH,
			title: MY_BUSINESS_ROUTES.FORECAST_TITLE,
			element: <MyBusinessForecastPage/>,
		},
		{
			path: MY_BUSINESS_ROUTES.MARKET_PATH,
			title: MY_BUSINESS_ROUTES.MARKET_TITLE,
			element: <MyBusinessMarketPage/>,
		},
		{
			path: MY_BUSINESS_ROUTES.PERFORMANCE_PATH,
			title: MY_BUSINESS_ROUTES.PERFORMANCE_TITLE,
			element: <MyBusinessPerformancePage/>,
		},
	]

	// Mapping admins are a separate, narrower feature — only ops/data
	// leads should touch the bridge to Price Seeker.
	const adminRoutes = userData?.featuresV2?.my_business_admin ? [
		{
			path: MY_BUSINESS_ROUTES.ADMIN_PATH,
			title: MY_BUSINESS_ROUTES.ADMIN_TITLE,
			element: <MyBusinessAdminPage/>,
		},
	] : []

	const children = [...dashboardRoutes, ...adminRoutes]

	return [{
		id: FEATURES_TYPE.MY_BUSINESS,
		path: MY_BUSINESS_ROUTES.PATH,
		title: MY_BUSINESS_ROUTES.TITLE,
		icon: 'briefcase',
		element: <AppLayout/>,
		children: [
			{ index: true, element: <Navigate to={MY_BUSINESS_ROUTES.REVENUE_PATH} replace/> },
			...children,
		],
	}]
}
